import { queryOptions } from '@tanstack/react-query'
import { getReadiness } from './api'

export const sportsVerifierQueryKeys = {
  all: ['sports-verifier'] as const,
  readiness: () => [...sportsVerifierQueryKeys.all, 'readiness'] as const,
}

export function readinessQueryOptions() {
  return queryOptions({
    queryKey: sportsVerifierQueryKeys.readiness(),
    queryFn: getReadiness,
  })
}
